import React, { useEffect } from "react";
import { Auth } from "aws-amplify";

const LoginScreen = () => {
  useEffect(() => {
    if (process.env.REACT_APP_OKTA_DISABLED === "true") {
      Auth.federatedSignIn();
    } else {
      Auth.federatedSignIn({ customProvider: "okta-login" });
    }
  }, []);

  return <div />;
};

export default LoginScreen;
